import { PaymentsTab } from '@/features/events/components/Detail/Tabs/PaymentsTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/payments')({
  component: PaymentsTab,
});
